import { render } from "./TextareaInputLang.vue?vue&type=template&id=5162a1e0"
import script from "./TextareaInputLang.vue?vue&type=script&lang=js"
export * from "./TextareaInputLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__